export const Footer = () => {
  return (
    <footer className="bg-blue-25 w-full py-2 flex flex-wrap items-center justify-center">
      <div className="flex flex-wrap  gap-y-5 justify-around md:justify-between items-center max-w-[349px] md:max-w-[1170px] w-full">
        <a href="https://mvs.gov.ua" target="_blank" rel="noreferrer nofollow">
          <img
            className="mx-auto"
            src="/images/mvs.svg"
            width="77"
            height="35"
            alt="мінестерство внутрішніх справ"
          />
        </a>
        <a
          href="https://infotech.gov.ua"
          target="_blank"
          rel="noreferrer nofollow"
        >
          <img
            className="mx-auto"
            src="/images/infotech.svg"
            width="114"
            height="34"
            alt="infotech"
          />
        </a>
        <a href="https://dsns.gov.ua" target="_blank" rel="noreferrer nofollow">
          <img
            className="mx-auto"
            src="/images/dsns.svg"
            width="122"
            height="24"
            alt="dsns"
          />
        </a>

        <a href="https://egap.in.ua" target="_blank" rel="noreferrer nofollow">
          <img
            className="mx-auto"
            src="/images/sch.svg"
            width="99.27"
            height="31.82"
            alt="Sch"
          />
        </a>

        <a href="https://egap.in.ua" target="_blank" rel="noreferrer nofollow">
          <img
            className="mx-auto"
            src="/images/egap.svg"
            width="36.91"
            height="42"
            alt="Egap"
          />
        </a>

        <a href="https://eef.org.ua" target="_blank" rel="noreferrer nofollow">
          <img
            className="mx-auto"
            src="/images/europe.svg"
            width="61.09"
            height="25.45"
            alt="Eu"
          />
        </a>
      </div>
    </footer>
  );
};
